import { useState, useRef, useEffect } from "react";
import { getValueFromPixels } from "./Slider.operations";
function isTouchEvent(ev) {
  return "touches" in ev;
}
const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
const useDragEvents = ({ min, max, value, sliderSize, updateValue, step }) => {
  const lastValue = useRef(value);
  const [dragging, setDragging] = useState(false);
  const prevDragging = usePrevious(dragging);
  const onMouseMove = (e) => {
    if (!dragging)
      return;
    const { left: sliderX, width: sliderWidth } = sliderSize;
    const clientX = isTouchEvent(e) ? e.touches[0].clientX : e.clientX;
    const newX = clientX - sliderX;
    const newValue = getValueFromPixels(min, max, newX, sliderWidth, step);
    updateValue(newValue, false);
    lastValue.current = newValue;
    e.stopPropagation();
    if (e.cancelable)
      e.preventDefault();
  };
  const onMouseDown = (e) => {
    setDragging(true);
    e.stopPropagation();
    if (e.cancelable && e.type !== "touchstart")
      e.preventDefault();
  };
  const onMouseUp = (e) => {
    setDragging(false);
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("touchmove", onMouseMove);
    document.removeEventListener("mouseup", onMouseUp);
    document.removeEventListener("touchend", onMouseUp);
    updateValue(lastValue.current, true);
    e.stopPropagation();
    if (e.cancelable)
      e.preventDefault();
  };
  useEffect(() => {
    if (dragging && !prevDragging) {
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("touchmove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
      document.addEventListener("touchend", onMouseUp);
    }
    return () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("touchmove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("touchend", onMouseUp);
    };
  }, [dragging]);
  return onMouseDown;
};
export default useDragEvents;
